export type PageTitleNavItem = {
  name: string;
  href: string;
  children?: { name: string; href: string }[];
};

/**
 * Resolves the main layout top-bar title for a route.
 * Uses the full navigation catalog (not permission-filtered) so denied pages
 * still show the correct page name.
 */
export function resolvePageTitle(
  pathname: string,
  navigation: PageTitleNavItem[],
  settingsNavigation: PageTitleNavItem[],
  extraTitles: ReadonlyArray<{ pathname: string; name: string }>,
  appName: string,
): string {
  for (const item of navigation) {
    if (item.href === pathname) {
      return item.name;
    }
    for (const child of item.children ?? []) {
      if (child.href === pathname) {
        return child.name;
      }
    }
  }

  const settingsMatch = settingsNavigation.find((item) =>
    pathname.startsWith(item.href),
  );
  if (settingsMatch) {
    return settingsMatch.name;
  }

  const extra = extraTitles.find((item) => item.pathname === pathname);
  if (extra) {
    return extra.name;
  }

  return appName;
}
